var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenBottle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 512,
      width: 512
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {},
    transform: "translate(0,0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384.47 9.938 320.436 26.03 181.03 165.438c-46.298 46.3 1.17 87.987-48.25 137.407l-81.593 81.594a32.516 32.516 0 0 0-3.718.03c-5.936.42-13.572 2.884-19.94 9.25-6.365 6.367-8.423 13.597-8.843 19.532-.418 5.935.87 11.557 2.907 17.47 4.076 11.823 12.242 24.43 23.718 35.905 11.477 11.476 24.05 19.642 35.875 23.72 5.912 2.037 11.565 3.324 17.5 2.905 5.936-.42 12.915-2.727 19.282-9.094 6.365-6.366 9.048-13.752 9.467-19.687.27-3.817-.147-7.53-1.03-11.25l78.374-78.376c49.42-49.42 91.108-1.95 137.407-48.25l160.938-160.938-107 12.156 7.78-101.593L327.47 104c3.406-34.72 23.273-64.073 57-94.063zm1.217 218.906 13.438 13.437-65.344 65.314c-25.316 25.317-51.6 25.56-73.874 25.656-22.274.098-40.82-.075-63.5 22.594l-77.625 78.5c-2.994-5.3-6.705-10.628-11.093-15.813l75.282-76.124c26.74-26.74 54.44-27.996 76.936-28.094 22.495-.097 39.457.857 60.438-20.125l65.343-65.343zm-344.78 175.5c2.838-.034 7.036.442 11.28 1.906 9.702 3.345 21.423 10.86 32.032 21.47 10.608 10.608 18.123 22.328 21.467 32.03 1.673 4.85 1.79 9.35 1.594 12.125-.28 1.417-.234 1.427-1.593 1.625-2.774.196-6.9-.327-11.75-2-9.696-3.343-21.395-10.9-32-21.5-10.608-10.61-18.155-22.33-21.5-32.03-1.672-4.852-2.446-9.195-2.25-11.97.038-1.55.02-1.547 1.594-1.625.348-.025.72-.026 1.126-.03z",
    fill: "#000000",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenBottle);
export default __webpack_public_path__ + "static/media/broken_bottle.4a94136b339d3e406f4b04eefa15ea11.svg";
export { ForwardRef as ReactComponent };